/**
 * Keep walkthroughs dormant without deleting their routes, steps, or copy.
 * Re-enable them here when the product is ready to expose them again.
 */
export const WALKTHROUGHS_ENABLED = false;
